// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1VLFq","header":"header--1ATtR","logo":"logo--2HQB4","userName":"userName--3qoqK"};